import { render, staticRenderFns } from "./LandingHero.vue?vue&type=template&id=4f53f892&scoped=true"
import script from "./LandingHero.vue?vue&type=script&lang=ts"
export * from "./LandingHero.vue?vue&type=script&lang=ts"
import style0 from "./LandingHero.vue?vue&type=style&index=0&id=4f53f892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f53f892",
  null
  
)

export default component.exports